import { API_URLS } from "constants/apiConstants";
import { User } from "../types/entities";
import { ApiClient, ApiResponse } from "./requestExecutor";

export class UserApi extends ApiClient {
  public login = async (
    email: string,
    password: string
  ): Promise<ApiResponse<User>> => {
    try {
      return this.post<User>(
        API_URLS.customer.loginUrl,
        JSON.stringify({ email, password })
      ) as Promise<ApiResponse<User>>;
    } catch (error) {
      console.error("Error al iniciar sesión.", error);
      throw error;
    }
  };

  public register = async (customer: User): Promise<ApiResponse<User>> => {
    try {
      return this.post<User>(
        API_URLS.customer.registerUrl,
        JSON.stringify(customer)
      ) as Promise<ApiResponse<User>>;
    } catch (error) {
      console.error("Error al registrar al cliente.\n", error);
      throw error;
    }
  };

  public googleLogin = async (customer: User): Promise<ApiResponse<User>> => {
    try {
      return this.post<User>(
        API_URLS.customer.logInWithGoogleUrl,
        JSON.stringify(customer)
      ) as Promise<ApiResponse<User>>;
    } catch (error) {
      console.error("Error al registrar el cliente con Google.\n", error);
      throw error;
    }
  };

  public update = async (customer: User): Promise<ApiResponse<User>> => {
    try {
      console.log(customer);
      return this.put<User>(
        API_URLS.customer.updateUrl,
        JSON.stringify(customer)
      ) as Promise<ApiResponse<User>>;
    } catch (error) {
      console.error("Error al actualizar el cliente.\n", error);
      throw error;
    }
  };

  public updatePassword = async (id: string, password: string) => {
    try {
      await this.put<User>(
        API_URLS.customer.updatePassword,
        JSON.stringify({ id, password })
      );
    } catch (error) {
      console.error("Error al actualizar la contraseña.\n", error);
      throw error;
    }
  };

  public forgotPassword = (
    email: string
  ): Promise<ApiResponse<{ id: string }>> => {
    try {
      return this.post<{ id: string }>(
        API_URLS.customer.forgotPasswordUrl,
        JSON.stringify({ email })
      );
    } catch (error) {
      console.error(
        "Error al enviar mail de recuperación de contraseña:",
        error
      );
      throw error;
    }
  };

  public validateToken = async (email: string, token: string) => {
    try {
      return this.post(
        API_URLS.customer.validateTokenUrl,
        JSON.stringify({ email, token })
      );
    } catch (error) {
      console.error("Error al validar el token enviado:", error);
      throw error;
    }
  };
}
